// Export the Component Definition for use in Contentful Studio
export {
  BrandVideoContentfulComponentDefinition,
  VideoContentfulComponentDefinition,
} from './videoContentfulDefinition';
export {default} from './Video';
